<template>
<section class="premium-section bg-grey">

  <div class="container">

    <!-- ================= VIDEO PLAYER ================= -->
    <!-- ================= VIDEO / PROMO SECTION ================= -->

    <!-- 🎬 VIDEO PLAYER (If subscribed) -->
  <template v-if="!isCheckingAccess">
    <div v-if="currentVideo && hasActivePlan"
        ref="playerSection"
        class="video-player-wrapper">

      <div class="video-container">
        <video
          ref="videoPlayer"
          controls
          autoplay
          class="main-video">
        </video>
      </div>

      <h2 class="video-title">{{ currentVideo.title }}</h2>
    </div>

    <!-- 🖼 PROMOTIONAL SLIDER (If NOT subscribed) -->
    <div v-else-if="promotionalImages.length && !hasActivePlan"
     class="promo-slider">

      <div class="promo-wrapper">

        <button class="promo-arrow left"
                @click="prevSlide">‹</button>

        <div class="promo-slide">
          <img :src="promotionalImages[currentSlide]"
              alt="Promotional Image" />
        </div>

        <button class="promo-arrow right"
                @click="nextSlide">›</button>

      </div>

    </div>

  </template>   
    <!-- ================= SPONSOR SLIDER ================= -->
    <!-- ================= SPONSOR SLIDER ================= -->
    <div v-if="sponsors.length && !hasActivePlan"
     class="sponsor-slider">

      <div class="sponsor-wrapper">

        <div class="sponsor-track"
            :style="{
              transform: `translateX(-${currentSponsor * 100}%)`
            }">

          <a v-for="sponsor in sponsors"
            :key="sponsor.premium_sponsor_id"
            :href="sponsor.link"
            target="_blank"
            rel="noopener noreferrer"
            class="sponsor-item">

            <img :src="sponsor.image_url"
                alt="Sponsor" />
          </a>

        </div>

      </div>

    </div>


    <!-- ================= STREAMING SHOWS ================= -->
    <div v-if="shows.length" class="mb-5">
      <h2 class="section-title">Programas en streaming</h2>

      <div class="category-wrapper">

        <button class="arrow left"
                @click="scrollLeft('shows')">‹</button>

        <div class="horizontal-scroll"
             ref="showsScroll">

          <div v-for="show in shows"
               :key="show.show_video_id"
               class="video-card"
               @click="selectVideo(show,'show')">

            <img :src="show.thumbnail_url" />
            <p>{{ show.title }}</p>
          </div>

        </div>

        <button class="arrow right"
                @click="scrollRight('shows')">›</button>

      </div>
    </div>

    <!-- ================= PREMIUM CATEGORIES ================= -->
    <div v-for="category in categories"
         :key="category.premium_video_category_id"
         class="mb-5">

      <h2 class="section-title">{{ category.title }}</h2>

      <div class="category-wrapper">

        <!-- LEFT ARROW -->
        <button class="arrow left"
                @click="scrollLeft(category)">
          ‹
        </button>

        <!-- SCROLL AREA -->
        <div class="horizontal-scroll"
             :ref="'cat_' + category.premium_video_category_id"
             @scroll="(e)=>loadMoreVideos(category,e)">

          <div v-for="video in category.videos"
               :key="video.premium_video_id"
               class="video-card"
               @click="selectVideo(video,'premium')">

            <img :src="video.thumbnail_url" />
            <p>{{ video.title }}</p>
          </div>

          <div v-if="category.loading"
               class="loading-small">
            Loading...
          </div>

        </div>

        <!-- RIGHT ARROW -->
        <button class="arrow right"
                @click="scrollRight(category)">
          ›
        </button>

      </div>

    </div>

    <!-- Vertical Loading -->
    <div v-if="loadingCategories"
         class="loading-bottom">
      Cargando más categorías...
    </div>

  </div>

</section>
</template>
<script>
import { HTTP } from '../../_helper/http-constants.js'
import Hls from 'hls.js'

export default {

data() {
  return {
    latestShow: null,
    shows: [],
    categories: [],
    currentVideo: null,

    categoryNext: null,
    loadingCategories: false,
    hasActivePlan: false,
    isLoggedIn: false,
    promotionalImages: [],
    currentSlide: 0,
    autoSlideInterval: null,
    sponsors: [],
    currentSponsor: 0,
    sponsorInterval: null,
    isCheckingAccess: true
  }
},

methods: {

  nextSlide() {
    if (!this.promotionalImages.length) return;

    this.currentSlide =
      (this.currentSlide + 1) % this.promotionalImages.length;
  },

  prevSlide() {
    if (!this.promotionalImages.length) return;

    this.currentSlide =
      (this.currentSlide - 1 + this.promotionalImages.length)
      % this.promotionalImages.length;
  },

  startAutoSlide() {
    if (this.autoSlideInterval) return;

    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 4000);
  },

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  },

  nextSponsor() {
    if (!this.sponsors.length) return;

    this.currentSponsor =
      (this.currentSponsor + 1) % this.sponsors.length;
  },

  startSponsorAutoSlide() {
    if (this.sponsorInterval) return;

    this.sponsorInterval = setInterval(() => {
      this.nextSponsor();
    }, 3000); // every 3 sec
  },

  stopSponsorAutoSlide() {
    if (this.sponsorInterval) {
      clearInterval(this.sponsorInterval);
      this.sponsorInterval = null;
    }
  },

  /* ================= INITIAL LOAD ================= */
  async fetchPremium(page = 1) {

    if (this.loadingCategories) return;

    this.loadingCategories = true;

    const res = await HTTP.get(`/premium/home?page=${page}`);

    if (res.data.status) {

      if (page === 1) {
        this.latestShow = res.data.latest_show;
        this.shows = res.data.shows.data;

        this.promotionalImages = this.shows
        .filter(s => s.promotional_image_url)
        .map(s => s.promotional_image_url);

        this.sponsors = res.data.premium_sponsors || [];

        // if (this.latestShow) {
        //   this.selectVideo(this.latestShow,'show');
        // }
      }

      const cats = res.data.categories.data;

      cats.forEach(cat => {
        cat.videos = cat.latest_videos;
        cat.videoPage = 1;
        cat.videoNext = true;
        cat.loading = false;
      });

      if (page === 1) {
        this.categories = cats;
      } else {
        this.categories.push(...cats);
      }

      this.categoryNext = res.data.categories.next_page_url;
    }

    this.loadingCategories = false;
  },

  async checkAccess() {

    try {

      const user = JSON.parse(localStorage.getItem('user'));
      this.isLoggedIn = !!user;

      if (!user) {
        this.hasActivePlan = false;
        return;
      }

      const res = await HTTP.get('/subscription/status');

      if (res.data.status && res.data.is_active) {
        this.hasActivePlan = true;
      } else {
        this.hasActivePlan = false;
      }

    } catch (e) {
      this.hasActivePlan = false;
    }
     this.isCheckingAccess = false;
  },

  /* ================= SELECT VIDEO ================= */
 async selectVideo(video, type) {

  // 🔥 If not logged in
  if (!this.isLoggedIn) {

    if (confirm("Subscribe to watch this video")) {
      this.$router.push('/login');
    }

    return;
  }

  // 🔥 Logged in but no active plan
  if (!this.hasActivePlan) {

    if (confirm("Subscribe to watch this video")) {
      this.$router.push('/subscription');
    }

    return;
  }

  // 🔥 User has active plan → Play video
  try {

    const res = await HTTP.post('/video/play', {
      type: type,
      id: type === 'show'
        ? video.show_video_id
        : video.premium_video_id
    });

    if (res.data.status) {

      this.currentVideo = video;

      this.$nextTick(() => {

        this.playVideo(res.data.video_source);

        if (this.$refs.playerSection) {
          window.scrollTo({
            top: this.$refs.playerSection.offsetTop - 80,
            behavior: 'smooth'
          });
        }

      });
    }

  } catch (e) {
    console.error(e);
  }

},
  /* ================= PLAY VIDEO ================= */
  playVideo(source) {

  const video = this.$refs.videoPlayer;
  if (!video) return;

  // 🔥 STOP previous playback
  video.pause();
  video.currentTime = 0;

  if (video.hlsInstance) {
    video.hlsInstance.destroy();
  }

  if (Hls.isSupported() && source.endsWith('.m3u8')) {

    const hls = new Hls();
    hls.loadSource(source);
    hls.attachMedia(video);

    video.hlsInstance = hls;

  } else {
    video.src = source;
  }

  video.play();
},

  /* ================= HORIZONTAL SCROLL ================= */
  scrollLeft(category) {

    const el = category === 'shows'
      ? this.$refs.showsScroll
      : this.$refs['cat_' + category.premium_video_category_id][0];

    el.scrollBy({ left: -400, behavior:'smooth' });
  },

  async scrollRight(category) {

    const el = category === 'shows'
      ? this.$refs.showsScroll
      : this.$refs['cat_' + category.premium_video_category_id][0];

    // Scroll first
    el.scrollBy({ left: 400, behavior: 'smooth' });

    // Wait for scroll animation
    setTimeout(async () => {

      const reachedEnd =
        el.scrollLeft + el.clientWidth >= el.scrollWidth - 20;

      if (!reachedEnd) return;

      if (!category.videoNext || category.loading) return;

      category.loading = true;

      const nextPage = category.videoPage + 1;

      try {

        const res = await HTTP.get(
          `/premium/category/${category.premium_video_category_id}?page=${nextPage}`
        );

        const newVideos = res.data.data.data;

        if (newVideos.length > 0) {
          category.videos.push(...newVideos);
          category.videoPage = nextPage;
        }

        if (!res.data.data.next_page_url) {
          category.videoNext = false;
        }

      } catch (err) {
        console.error(err);
      }

      category.loading = false;

    }, 400); // wait for smooth scroll
  },

  /* ================= LOAD MORE VIDEOS ================= */
  async loadMoreVideos(category, e) {

  const el = e.target;

  // Remaining scroll space
  const remaining =
    el.scrollWidth - (el.scrollLeft + el.clientWidth);

  // 🔥 Trigger earlier (about 4 cards before end)
  if (remaining > 800) return;

  if (!category.videoNext || category.loading) return;

  category.loading = true;

  const nextPage = category.videoPage + 1;

  try {

    const res = await HTTP.get(
      `/premium/category/${category.premium_video_category_id}?page=${nextPage}`
    );

    const newVideos = res.data.data.data;

    if (newVideos.length > 0) {
      category.videos.push(...newVideos);
      category.videoPage = nextPage;
    }

    if (!res.data.data.next_page_url) {
      category.videoNext = false;
    }

  } catch (err) {
    console.error(err);
  }

  category.loading = false;
},
  /* ================= VERTICAL SCROLL ================= */
  async handleVerticalScroll() {

    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 200
    ) {

      if (!this.categoryNext) return;

      const nextPage =
        this.categoryNext.split('page=')[1];

      await this.fetchPremium(nextPage);
    }
  }

},
async mounted() {

    await this.checkAccess();      // wait subscription check
    await this.fetchPremium(1);    // wait content load

    this.startSponsorAutoSlide();

    await this.$nextTick();        // wait DOM update

    if (this.hasActivePlan && this.latestShow) {
      this.selectVideo(this.latestShow, 'show');
    }

    window.addEventListener('scroll', this.handleVerticalScroll);
      if (!this.hasActivePlan) {
        this.startAutoSlide();
      }
  },

  beforeDestroy() {
    window.removeEventListener('scroll',
        this.handleVerticalScroll);

    this.stopAutoSlide();
    this.stopSponsorAutoSlide();
  }
}
</script>
<style scoped>

/* ================= PROMO SLIDER ================= */

.promo-slider {
  margin-bottom: 40px;
}

.promo-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 12px;
}

.promo-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.promo-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 45px;
  height: 80px;
  background: rgba(0,0,0,0.6);
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
}

.promo-arrow.left { left: 10px; }
.promo-arrow.right { right: 10px; }

.promo-arrow:hover {
  background: rgba(0,0,0,0.9);
}

/* Mobile */
@media (max-width: 768px) {
  .promo-wrapper {
    height: 220px;
  }

  .promo-arrow {
    display: none;
  }
}





.video-player-wrapper {
  margin-bottom: 40px;
}

.video-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 ratio */
  background: black;
  border-radius: 12px;
  overflow: hidden;
}

.main-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-title {
  margin-top: 15px;
  color: white;
}

.category-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 -10px; /* small bleed effect */
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;

  width: 50px;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    to right,
    rgba(0,0,0,0.9),
    rgba(0,0,0,0.4),
    transparent
  );

  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  transition: 0.3s ease;
}
/* Hide arrows on mobile */
@media (max-width: 768px) {
  .arrow {
    display: none;
  }
}
/* LEFT */
.arrow.left {
  left: 0;
  border-radius: 12px 0 0 12px;
}

/* RIGHT */
.arrow.right {
  right: 0;
  background: linear-gradient(
    to left,
    rgba(0,0,0,0.9),
    rgba(0,0,0,0.4),
    transparent
  );
  border-radius: 0 12px 12px 0;
}

.arrow:hover {
  transform: translateY(-50%) scale(1.1);
}

.horizontal-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;   /* 🔥 prevent vertical scrollbar */
  gap: 20px;
  scroll-behavior: smooth;
  padding: 0 60px;

  /* 🔥 Hide scrollbar (Chrome, Safari, Edge) */
  scrollbar-width: none;        /* Firefox */
  -ms-overflow-style: none;     /* IE 10+ */
}

.horizontal-scroll::-webkit-scrollbar {
  display: none;                /* Chrome/Safari */
}
.video-card {
  flex: 0 0 25%;
  max-width: 25%;
  background: #111;
  padding: 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.3s;
  color: white;
}
.video-card:hover {
  transform: scale(1.05);
}

.video-card img {
  width: 100%;
  border-radius: 8px;
}

.section-title {
  color: white;
  margin-bottom: 20px;
}

.loading-small {
  min-width: 120px;
  display:flex;
  align-items:center;
  justify-content:center;
  color:white;
}

.loading-bottom {
  text-align:center;
  padding:20px;
  color:white;
}
/* Tablet */
@media (max-width: 1024px) {
  .video-card {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .video-card {
    flex: 0 0 60%;
    max-width: 60%;
  }

  .video-title {
    font-size: 16px;
    text-align: center;
  }

  .section-title {
    font-size: 18px;
  }
}
@media (max-width: 768px) {

  .horizontal-scroll {
    padding: 0; /* remove left-right space */
  }

}
@media (max-width: 768px) {

  .section-title {
    text-align: left;
    padding-left: 4px;
  }

}

@media (max-width: 768px) {
  .premium-section .container {
    padding: 0 12px;
  }

  .video-card {
    padding: 8px;
  }
}
@media (max-width: 768px) {

  .premium-section .container {
    max-width: 100% !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

}
.premium-section {
  overflow-x: hidden;
}



/* ================= SPONSOR SLIDER ================= */

.sponsor-slider {
  margin: 30px 0;
}

.sponsor-wrapper {
  width: 100%;
  height: 120px;
  overflow: hidden;
  border-radius: 14px;
  position: relative;
}

.sponsor-track {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.8s ease-in-out; /* 🔥 Smooth slide */
}

.sponsor-item {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
}

.sponsor-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
  transition: opacity 0.5s ease;
}

/* Subtle hover effect */
.sponsor-item:hover img {
  opacity: 0.85;
}

/* Mobile */
@media (max-width: 768px) {
  .sponsor-wrapper {
    height: 80px;
  }
}
</style>